export const userActionTypes = {
	SET_CURRENT_USER: 'SET_CURRENT_USER',
	SET_USER_SUBSCRIPTION: 'SET_USER_SUBSCRIPTION',
};
